import Vue from 'vue'
import VueRouter from 'vue-router'
//引入home，user
import HomePage from '../views/HomePage.vue'
import UserPage from '../views/UserPage.vue'
import MainPage from '../views/MainPage.vue'

import PageOne from '../views/PageOne.vue'
import PageTwo from '../views/PageTwo.vue'
import MallPage from '../views/MallPage.vue'
import EssayPage from '../views/EssayPage.vue'
import UserInfoPage from '../views/UserInfoPage.vue'
import VipPage from '../views/VipPage.vue'
import LessonPage from '../views/LessonPage.vue'
import RecordingPage from '@/views/RecordingPage.vue'
import LoginPage from '@/views/LoginPage.vue' // 确保你有这个登录页面组件
import AboutPage from '@/views/AboutPage.vue'
import CoursePage from '@/views/CoursePage.vue'



// 使用 Vue Router
Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login',
        component: LoginPage
    },
    {
        path: '/',
        component: MainPage,
        // 添加路由守卫需要的元字段
        meta: { requiresAuth: true },
        //重定向到home
        redirect: '/home',
        children: [
            {
                path: 'home',
                name: 'home',
                component: HomePage
            },
            {
                path: 'user',
                name: 'user',
                component: UserPage
            },
            {
                path: 'lesson',
                name: 'lesson',
                component: LessonPage
            },
            {
                path: 'essay',
                name: 'essay',
                component: EssayPage
            },
            {
                path: 'recording',
                name: 'recording',
                component: RecordingPage
            },
            {
                path: 'course',
                name: 'course',
                component: CoursePage
            },
            {
                path: 'mall',
                name: 'mall',
                component: MallPage
            },
            {
                path: 'vip',
                name: 'vip',
                component: VipPage
            },
            {
                path: 'about',
                name: 'about',
                component: AboutPage
            },
            {
                path: 'page1',
                name: 'page1',
                component: PageOne
            },
            {
                path: 'page2',
                name: 'page2',
                component: PageTwo
            },
            {
                path: 'userInfoPage',
                name: 'userInfoPage',
                component: UserInfoPage
            }
        ]
    },
    // 添加一个重定向规则，确保根路径直接跳转到登录页
    {
        path: '*',
        redirect: '/login'
    }
]

const router = new VueRouter({
    routes // (缩写) 相当于 routes: routes
})

// 添加路由守卫
router.beforeEach((to, from, next) => {
    // 检查目标路由是否需要认证
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // 这里假设你有一个方法来检查用户是否已登录
        // 例如检查 localStorage 或 Vuex 中的登录状态
        const isAuthenticated = localStorage.getItem('isAuthenticated') // 或者其他认证方式
        
        if (!isAuthenticated) {
            // 如果未登录，重定向到登录页面
            next({
                path: '/login',
                query: { redirect: to.fullPath } // 保存目标路径，登录后可以跳转回来
            })
        } else {
            next() // 继续导航
        }
    } else {
        next() // 不需要认证的路由，直接放行
    }
})

// 解决重复导航报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
    })
}

export default router